import NavBar from './components/NavBar';
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Shop from './pages/Shop';
import Blog from './pages/Blog';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import ProductDetail from './pages/ProductDetail';
import BlogPostDetail from './pages/BlogPostDetail';

import AdminLanding from './components/admin/AdminLanding';
import AdminSessionGuard from './components/admin/AdminSessionGuard';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminBlogs from './pages/admin/AdminBlogs';
import AdminProducts from './pages/admin/AdminProducts';
import AdminHeroSlider from './pages/admin/AdminHeroSlider';
import AdminHomeContent from './pages/admin/AdminHomeContent';

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPostDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminLanding />}/>
          <Route path="/admin/dashboard" element={<AdminSessionGuard><AdminDashboard /></AdminSessionGuard>} />
          <Route path="/admin/dashboard/blogs" element={<AdminSessionGuard><AdminBlogs /></AdminSessionGuard>} />
          <Route path="/admin/dashboard/products" element={<AdminSessionGuard><AdminProducts /></AdminSessionGuard>} />
          <Route path="/admin/dashboard/heroSlider" element={<AdminSessionGuard><AdminHeroSlider /></AdminSessionGuard>} />
          <Route path="/admin/dashboard/home-content" element={<AdminSessionGuard><AdminHomeContent /></AdminSessionGuard>} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
